"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../../../helpers/index.js");
var stringField = _index.formatters.stringField;
var filteredBrands = ['apple', 'samsung', 'google', 'zte', 'sonim', 'motorola', 'tcl', 'nubia'];
var regex = new RegExp("^(".concat(filteredBrands.join('|'), ")_"));
var formatProductName = function formatProductName(value) {
  var formatted = stringField(value);
  return formatted.replace(regex, '');
};
var _default = exports["default"] = formatProductName;